/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import './PaymentsThankYouPage.scss';

import { Button, CardWrapper, Title } from '@boi/core/lib';
import { faExclamationCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

import { SELECTED_HOME_QUOTE_STORAGE } from '../../constants';
import { backToHome } from '../../constants/buttonLabelConstants';
import { exclamationColor } from '../../constants/colors';
import { localPhoneNumber } from '../../constants/phoneNumbers';
import { getObjectFromSessionStorage, isAgent, sendAnalyticsEvent } from '../../helpers';
import { routes } from '../../routes';

const requestFailure = getObjectFromSessionStorage('request-interupted-flag');
const className = `c-PaymentsThankYouPage${requestFailure.interrupted === true ? '__request_interrupted' : ''}`;
const classes = 'c-ThankYouPageError';
const selectedHomeQuote = getObjectFromSessionStorage(SELECTED_HOME_QUOTE_STORAGE);

const CALLBACK_LINK = 'https://digital.bankofireland.com/services/insure-and-protect/insurance-callback/#application/page/1';

const getErrorText = () => {
  let error_text_content = '';
  const policyReference = selectedHomeQuote?.policy_code ? selectedHomeQuote?.policy_code : 'reference_number';

  if (requestFailure?.interrupted === true) {
    error_text_content = <>
      <p>We’re sorry, but we’re unable to display your policy confirmation.</p>
      <p style={{ fontWeight: 'bold' }}>Your payment may have been successful. {<br />}Please do not submit another
        payment</p>
      <br />
      <p>Please contact us on{' '}<a href={`tel:${localPhoneNumber}`}>{localPhoneNumber}</a> or <a href={CALLBACK_LINK}>request
        a callback</a> and
        include your reference: <b>{policyReference}</b>. {<br />}Call from 9am to 5pm, Monday to
        Friday.</p>
      <p style={{ textAlign: 'left' }}>
        We’ll check the status of your payment and confirm whether your Home Insurance policy has been set up. </p>
      <p style={{ textAlign: 'left' }}>
        You can close this page after noting your reference number. Please do not restart the purchase or submit another
        payment.
      </p>
    </>;
  } else {
    error_text_content = <>
      Unfortunately, we have been unable to confirm your cover at this time. We
      need additional information to finalise your policy please call us on{' '}
      <a href={`tel:${localPhoneNumber}`}>{localPhoneNumber}</a>. Our lines are
      open Monday to Friday 9am-5pm. If any payment has been collected, it
      will be refunded within 5-10 working days.
    </>;
  }

  return error_text_content;
};

const getErrorIcon = () => {
  return requestFailure.interrupted ? faExclamationTriangle : faExclamationCircle;
};

const HomePaymentErrorPage = () => {
  if (requestFailure?.interrupted) {
    sendAnalyticsEvent({
      'agent_error': isAgent(),
      'policy_code': selectedHomeQuote?.policy_code,
      'time_if_failure': new Date().toISOString()
    }, 'bindStatusFailure', 'Home');
  }
  return (
    <div className={`${classes}`}>
      <CardWrapper>
        <div className={`${className}`}>
          <div className={`${className}__thankYouPageTextContainer`}>
            <div className={`${className}__primaryTextContainer`}>
              <FontAwesomeIcon
                icon={getErrorIcon()}
                className={`${className}--buttonIcon fa-lg`}
                color={exclamationColor}
                size="3x"
              />
            </div>
            <div className={`${className}__primaryTextContainerOneFailed`}>
              <Title type="h1" weight="light">
                <span id="PaymentsThankYouPage__thankYouText">
                  Policy Generation Failed
                </span>
              </Title>
            </div>
            <div className={`${className}__contentFailureTexthome`}>
              {getErrorText()}
            </div>
          </div>
          <div className={`${className}__buttonContainer`}>
            <div className={`${className}__buttonSpacing`}>
              <Link to={routes.wallet.url}>
                <Button secondary fluid data-ga id="PaymentsThankYouPage__home">
                  {backToHome}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </CardWrapper>
    </div>
  );
};

export default HomePaymentErrorPage;
